import { useEffectOnce } from 'react-use';

interface IUseDisableDragOptions {
	/** Если true, не блокирует drag для элементов с draggable="true" */
	allowDraggableElements?: boolean;
}

const useDisableDrag = (options?: IUseDisableDragOptions) => {
	useEffectOnce(() => {
		// Перетаскивание
		const handleDragging = (e: any) => {
			if (options?.allowDraggableElements) {
				const target = e.target as HTMLElement;
				let element: HTMLElement | null = target;
				while (element) {
					if (element.getAttribute?.('draggable') === 'true') {
						return;
					}
					element = element.parentElement;
				}
			}
			e.preventDefault();
		};
		document.addEventListener('dragstart', handleDragging);
		return () => document.removeEventListener('dragstart', handleDragging);
	});
};

export { useDisableDrag };
